import { useQuery } from "@tanstack/react-query";

import { initUseQuery } from "simplydo/core/query";
import SearchParams from "simplydo/core/searchParams";

import api from "api";

export const useMe = () => {
  const params = new SearchParams(window.location.search);
  const utmReferrer = params.get("utm-link");
  const { data: me } = useQuery(initUseQuery(api.users.me, [utmReferrer]));

  return me;
};
